<script setup lang="ts">
const props = defineProps<{
    open: boolean
}>()
</script>

<template>
    <i class="fa fa-fw fa-chevron-right" :class="{ open: props.open }"></i>
</template>

<style scoped>
i {
    transition: transform 300ms ease-in-out;
}

i.open {
    transform: rotate(90deg);
}
</style>
